import { render, staticRenderFns } from "./performances_table.vue?vue&type=template&id=070acd11"
import script from "./performances_table.vue?vue&type=script&lang=js"
export * from "./performances_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports